<template>
  <div class="home-page">
    <master-header />
    <section class="speakers">
      <h1>Speakers</h1>
      <div class="speakers-list">
        <ul class="inner">
          <li v-for="speaker, index in speakers" @click="goToSpeaker(index)">
            <div class="image-container">
              <img :src="speaker.image" />
            </div>
            <div class="details">
              <div class="name">{{speaker.name}}</div>
              <div class="description">{{speaker.title}}</div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="pillars inner">
      <div class="title">AN INTERDISCIPLINARY FORUM FEATURING THE LATEST AND MOST RELEVANT AREAS OF THE CANNABIS INDUSTRY TODAY.</div>
      <ul>
        <li class="medical">
          <router-link to="/pillar/medical">
            <h1>Medical &amp; Industrial Use</h1>
            <div class="board">
              <ul>
                <li>&middot; Cannabis &amp; the Opioid Epidemic</li>
                <li>&middot; Pharmaceuticals</li>
                <li>&middot; Autoimmune Diseases</li>
                <li>&middot; Neurological Diseases</li>
                <li>&middot; Cancer Treatment</li>
                <li>&middot; Cannabinoid System</li>
                <li>&middot; Medical Research Methods</li>
                <li>&middot; Hemp &amp; Textile Industry</li>
              </ul>
              <img src="../assets/pillars/medical/illustration.jpg" />
            </div>
          </router-link>
        </li>
        <li class="investment">
          <router-link to="/pillar/investment">
            <h1>Market &amp; Investment</h1>
            <div class="board">
              <ul>
                <li>&middot; Cannabis Capitol &amp; Financing</li>
                <li>&middot; Marketing</li>
                <li>&middot; Acquisition &amp; Merger</li>
                <li>&middot; Cash Management</li>
                <li>&middot; Entrepreneurship</li>
                <li>&middot; Local and State Markets</li>
                <li>&middot; Emerging Businesses</li>
              </ul>
              <img src="../assets/pillars/investment/illustration.jpg" />
            </div>
          </router-link>
        </li>
        <li class="policy">
          <router-link to="/pillar/policy">
            <h1>Policy &amp; Public Administration</h1>
            <div class="board">
              <ul>
                <li>&middot; State &amp; Federal Legislation</li>
                <li>&middot; Taxation</li>
                <li>&middot; Public Opinion</li>
                <li>&middot; Litigation</li>
                <li>&middot; Local Bureaucracy</li>
                <li>&middot; Political Opposition</li>
                <li>&middot; Lobbying Efforts</li>
                <li>&middot; Policy Endorsements</li>
              </ul>
              <img src="../assets/pillars/policy/illustration.jpg" />
            </div>
          </router-link>
        </li>
        <li class="social">
          <router-link to="/pillar/social">
            <h1>Social Impact &amp; Equity</h1>
            <div class="board">
              <ul>
                <li>&middot; Women in Cannabis</li>
                <li>&middot; Diversity and Inclusion</li>
                <li>&middot; Law Enforcement &amp; Activism</li>
                <li>&middot; Record Expungement</li>
                <li>&middot; Future of Public Consumption</li>
                <li>&middot; Community Development</li>
                <li>&middot; Tourism</li>
                <li>&middot; Youth &amp; Education</li>
              </ul>
              <img src="../assets/pillars/social/illustration.jpg" />
            </div>
          </router-link>
        </li>
      </ul>
    </section>
    <mini-divider class="breath"/>
    <section class="news inner">
      <router-link to="/workshops" class="photo-link mobile">
        <img src="../assets/home/workshop2.jpg" />
        <div class="text">
          <h1>CPES Workshops</h1>
        </div>
      </router-link>
      <router-link to="/latest" class="photo-link">
        <img src="https://mjbizmagazine.com/wp-content/uploads/2018/11/COVER-Main.jpg" />
        <div class="text">
          <h1>Latest News</h1>
        </div>
      </router-link>
      <div class="twitter">
        <a class="twitter-timeline" href="https://twitter.com/CPEsymposium?ref_src=twsrc%5Etfw" data-chrome="noheader nofooter noborders transparent" data-link-color="#41824E">Tweets by CPEsymposium</a>

      </div>
    </section>
    <divider />
    <section class="partners inner" v-if="showPartners">
      <div class="title">WE THANK OUR PARTNERS</div>
      <ul class="vignettes">
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
        <li><img src="../assets/partner_placeholder.png" /></li>
      </ul>
    </section>
    <div class="inner">
      <illustration />
    </div>
  </div>
</template>
<script>
  import Divider from '@/components/Divider.vue'
  import MiniDivider from '@/components/MiniDivider.vue'
  import Illustration from '@/components/Illustration.vue'
  import MasterHeader from '@/components/MasterHeader.vue'
  import RegisterButton from '@/components/RegisterButton.vue'
  import speakers from '@/lib/speakers'

  export default {
    name: 'home-page',
    components: { Divider, MasterHeader, RegisterButton, Illustration, MiniDivider },
    data() {
      return {
        showPartners: false,
        speakers
      }
    },
    mounted() {
      if (window.twttr) {
        twttr.widgets.load()
      }
    },
    methods: {
      goToSpeaker(index) {
        this.$router.push({ path: '/speaker', query: { speakerIndex: index }})
      },
    },
  }
</script>
<style scoped lang="scss">
  .home-page {
    position: relative;
  }
  .absolute {
    position: absolute;
  }
  .title {
    color: $color-2;
    text-align: center;
    padding: 35px 0 10px 0;
    font-size: 22px;
    font-weight: lighter;
  }
  .pillars {
    h1 {
      text-transform: uppercase;
      font-size: 18px;
      text-align: center;
    }
    >ul {
      overflow: hidden;
      >li {
        width: 25%;
        display: block;
        float: left;
        a {
          text-decoration: none;
          color: inherit;
        }
      }
    }
  }
  .board {
    position: relative;
    padding: 15px;
    border-radius: 15px;
    margin: 0 6px;
    transition: all 0.3s 0.1s;
    cursor: pointer;
    li {
      line-height: 25px;
      font-size: 16px;
    }
  }
  .medical {
    color: $color-1;
    .board {
      border: 20px solid $color-1;
      &:hover {
        background: $color-1;
        color: #fff;
      }
    }
  }
  .investment {
    color: $color-2;
    .board {
      border: 20px solid $color-2;
      &:hover {
        background: $color-2;
        color: #fff;
      }
    }
  }
  .policy {
    color: $color-3;
    .board {
      border: 20px solid $color-3;
      &:hover {
        background: $color-3;
        color: #fff;
      }
    }
  }
  .social {
    color: $color-4;
    .board {
      border: 20px solid $color-4;
      &:hover {
        background: $color-4;
        color: #fff;
      }
    }
  }
  .workshop {
    h1 {
      text-align: center;
      text-transform: uppercase;
      color: $color-2;
      font-size: 25px;
    }
    >div {
      overflow: hidden;
    }
    .photo-link {
      height: 277px;
    }
  }
  .news {
    overflow: hidden;
    .photo-link {
      height: 420px;
    }
    .twitter {
      height: 420px;
      overflow: auto;
      a {
        text-decoration: none;
        color: $color-1;
      }
    }
  }
  .photo-link {
    text-decoration: none;
    position: relative;
    display: block;
    overflow: hidden;
    .text {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0 20px 10px 20px;
      height: 100px;
      background: rgba(0, 0, 0, 0.5);
      h1 {
        text-transform: uppercase;
        font-size: 22px;
        font-weight: bold;
        color: #fff;
        position: absolute;
        bottom: 10px;
        left: 20px;
        text-align: left;
      }
    }
    img {
      width: 100%;
    }
  }
  .vignettes {
    overflow: hidden;
    li {
      display: block;
      box-sizing: border-box;
      float: left;
      img {
        width: 260px;
        margin: 30px;
      }
    }
  }
  .call4paper a {
    margin: 30px auto 0;
    width: 350px;
    display: block;
    text-decoration: none;
    font-size: 20px;
    text-transform: uppercase;
    background: $color-2;
    color: #fff;
    padding: 10px;
    border-radius: 4px;
    text-align: center;
    &:hover {
      background: $color-3;
    }
  }
  .breath {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .speakers {
    h1 {
      text-align: center;
      text-transform: uppercase;
      color: $color-2;
      font-size: 25px;
    }
    .speakers-list {
      padding: 20px 0;
      background: $color-14;
    }
    ul {
      overflow: hidden;
    }
    li {
      position: relative;
      margin-bottom: 45px;
      .image-container {
        position: relative;
        width: 310px;
        height: 310px;
        border-radius: 155px;
        overflow: hidden;
      }
      img {
        position: absolute;
        top: -15px;
        left: -15px;
        width: 340px;
        height: 340px;
      }
      .details {
        color: #fff;
        text-align: center;
        font-size: 22px;
        padding-top: 5px;
        height: 110px;
      }
      .name {
        font-weight: bold;
      }
    }
  }

  @media (min-width: 501px) {
    .speakers {
      li {
        width: calc(33.333% - 100px);
        margin-left: 50px;
        margin-right: 50px;
        box-sizing: border-box;
        float: left;
      }
    }
    .workshop {
      .photo-link {
        width: calc(33.333% - 10px);
        float: left;
        margin-left: 10px;
        &:first-child {
          width: 33.333%;
          margin-left: 0;
        }
      }
    }
    .news {
      .photo-link {
        width: 50%;
        float: left;
      }
      .twitter {
        width: calc(50% - 10px);
        margin-left: 10px;
        float: left;
      }
    }
    .board {
      height: 380px;
      img {
        position: absolute;
        left: 10px;
        bottom: 10px;
        width: 245px;
      }
    }
    .mobile {
      display: none;
    }
  }
  @media (max-width: 500px) {
    .speakers {
      li {
        .image-container {
          margin: 0 auto;
        }
        .details {
          padding: 10px 20px;
        }
      }
    }
    .call4paper a {
      width: 200px;
    }
    .workshop {
      display: none;
    }
    .pillars {
      >ul {
        >li {
          width: 100%;
          display: block;
          float: none;
          .board {
            color: #fff;
            img {
              border-radius: 20px;
            }
          }
        }
      }
    }
    .board {
      img {
        width: calc(100% - 20px);
        margin-top: 15px;
      }
    }
    .twitter {
      display: none;
    }
    .medical .board {
      background: $color-1;
    }
    .investment .board {
      background: $color-2;
    }
    .policy .board {
      background: $color-3;
    }
    .social .board {
      background: $color-4;
    }
    .news .photo-link {
      &.mobile {
        margin-bottom: 20px;
      }
      height: 241px;
    }
  }
</style>